import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateUserCompanyInformation(
    $userRoles: [String!]
    $companySize: String
    $companyWebsite: String
  ) {
    updateUserCompanyInformation(
      userRoles: $userRoles
      companySize: $companySize
      companyWebsite: $companyWebsite
    ) {
      id
      segment
    }
  }
`;

export const updateUserCompanyInformation = ({ userRoles, companySize, companyWebsite }) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { userRoles, companySize, companyWebsite },
  }).then(({ data }) => getSingleProp(data));
